<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/targetResponsibility/targetSplit' }">目标拆分</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.params.id ? "编辑" : "新增" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm formBox"
        size="small"
      >
        <el-form-item label="目标指标编号" prop="objectiveIndicatorId">
          <el-select v-model="ruleForm.objectiveIndicatorId" @change="goalSelectChange" placeholder="请选择指标级别" style="width: 100%">
            <el-option v-for="item in goalList" :key="item.id" :label="item.indicatorNumber"
              :value="item.id">
              <span style="float: left">{{ item.indicatorNumber }}</span>
              <span style="float: right;color: #8492a6; font-size: 13px">{{ item.indicatorName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0">
          <el-col :span="12">
            <el-form-item label="类型" prop="type">
              <el-select v-model="ruleForm.type" disabled placeholder="请选择类型" style="width: 100%">
                <el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年度" prop="year">
              <el-date-picker
                v-model="ruleForm.year"
                type="year"
                disabled
                value-format="yyyy"
                style="width: 100%"
                placeholder="选择年" />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0">
          <el-col :span="12">
            <el-form-item label="完成期限" prop="completionDate">
              <el-date-picker
                v-model="ruleForm.completionDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                disabled
                placeholder="选择日期时间"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="内容" prop="objectiveExplain">
          <el-input type="textarea" :rows="3" v-model="ruleForm.objectiveExplain" placeholder="请输入指标内容" />
        </el-form-item>
        <el-form-item label="项目" prop="objectiveContent">
          <el-input type="textarea" :rows="3" v-model="ruleForm.objectiveContent" placeholder="请输入项目" />
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0">
          <el-col :span="12">
            <el-form-item label="制定人部门" prop="producerDepId">
              <el-select
                v-model="ruleForm.producerDepId"
                placeholder="请选择制定人部门"
                style="width: 100%"
                @change="departChange"
              >
                <el-option v-for="item in departList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="制定人" prop="producerEmpId">
              <el-select
                v-model="ruleForm.producerEmpId"
                placeholder="请选择制定人"
                style="width: 100%"
                @change="user($event, 1)"
              >
                <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0">
          <el-col :span="12">
            <el-form-item label="制定时间" prop="creationTime">
              <el-date-picker
                v-model="ruleForm.creationTime"
                type="date"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考核标准" prop="objExaCriterionId">
              <el-select
                v-model="ruleForm.objExaCriterionId"
                placeholder="请选择考核标准"
                style="width: 100%"
              >
                <el-option v-for="item in standardList" :key="item.id" :label="item.title" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0">
          <el-col :span="12">
            <el-form-item label="考核时间" prop="examinationTime">
              <el-date-picker
                v-model="ruleForm.examinationTime"
                type="date"
                style="width: 100%"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核人" prop="departmentHeadEmpid">
              <el-select
                v-model="ruleForm.departmentHeadEmpid"
                placeholder="请选择审核人"
                style="width: 100%"
                @change="user($event, 3)"
              >
                <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0">
          <el-col :span="12">
            <el-form-item label="责任人部门" prop="dutyDepId">
              <el-select
                v-model="ruleForm.dutyDepId"
                placeholder="请选择责任人部门"
                style="width: 100%"
                @change="responseDepartChange"
              >
                <el-option v-for="item in departList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="责任人" prop="dutyPersonEmpid">
              <el-select
                v-model="ruleForm.dutyPersonEmpid"
                placeholder="请选择责任人"
                style="width: 100%"
                @change="user($event, 4)"
              >
                <el-option v-for="item in userList2" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item prop="definitionId" label="流程模板" v-if="!$route.params.id">
          <el-select :disabled="$route.params.id ? true : false" v-model="ruleForm.definitionId"
          placeholder="请添加" style="width:100%" @change="modelChange">
            <el-option
              v-for="m in modules"
              :key="m.id"
              :label="m.name"
              :value="m.definitionId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" style="width: 100%">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getGoalList, getGoalAddData, getAllDepartment, getDepartUser, getStandardList, goalSplitAdd, editSplit, splitInfo } from "@/api/processManager";
import { modulesList } from "@/api/model.js"
export default {
  name: "mainTargetAdd",
  data() {
    return {
      // 目标指标列表
      goalList: [],
      // 部门列表
      departList: [],
      // 标准列表
      standardList: [],
      // 人员的列表
      userList: [],
      userList2: [],
      typeList: [
        { id: 0, name: '年度目标' },
        { id: 1, name: '季度目标' },
        { id: 2, name: '月度目标' },
      ],
      // 表单数据
      ruleForm: {
        dutyPersonEmpid: '',
        objectiveExplain: '',
        objectiveContent: ''
      },
      rules: {
        objectiveIndicatorId: [{ required: true, message: '请选择目标指标编号' }],
        objectiveExplain: [{ required: true, message: '请输入内容' }],
        objectiveContent: [{ required: true, message: '请输入项目' }],
        companyLeaderEmpid: [{ required: true, message: '请选择指标级别' }],
        producerDepId: [{ required: true, message: '请选择制定人部门' }],
        producerEmpId: [{ required: true, message: '请选择制定人', trigger: 'blur' }],
        objExaCriterionId: [{ required: true, message: '请选择考核标准' }],
        creationTime: [{ required: true, message: '选择制定时间' }],
        examinationTime: [{ required: true, message: '请选择考核时间' }],
        departmentHeadEmpid: [{ required: true, message: '请选择审批人', trigger: 'blur' }],
        dutyDepId: [{ required: true, message: '请选择责任部门' }],
        dutyPersonEmpid: [{ required: true, message: '请选择责任人' }],
        definitionId: [{ required: true, message: '请选择' }]
      },
      tableData: [],
      modules: []
    };
  },
  created() {
    this.getGoalList();
    this.getDepart();
    this.getStandardList();
    this.getModulesList()
    // 编辑
    if(this.$route.params.id) {
      let obj = { ...this.$route.params }
      delete(obj.comAuditTime)
      delete(obj.companyLeaderAudit)
      delete(obj.depAuditTime)
      delete(obj.departmentHeadAudit)
      delete(obj.producerExplain)
      delete(obj.gmtCreate)
      delete(obj.depAuditStatus)
      delete(obj.comAuditStatus)
      delete(obj.dutyPersonAudit)
      delete(obj.dutyPersonAuditTime)
      delete(obj.dutyPersonAuditStatus)
      this.ruleForm = obj
      getDepartUser({ demId: obj.producerDepId }).then(res => {
        this.userList = res.body.data;
      })
      getDepartUser({ demId: obj.dutyDepId }).then(res => {
        this.userList2 = res.body.data;
      })
    }
    // 从目标列表跳转过来
    if(this.$route.params.jumpStatus) {
      let id = this.$route.params.goalId
      this.ruleForm.objectiveIndicatorId = Number(id)
      this.goalSelectChange(id);
    }
  },
  methods: {
    // 获取目标指标下拉框的数据
    getGoalList() {
      getGoalList({ isPage: 0}).then(res => {
        this.goalList = res.body.data
      })
    },
    // 获取标准列表
    getStandardList() {
      getStandardList().then(res => {
        this.standardList = res.body.data;
      })
    },
    // 获取所有部门
    getDepart() {
      getAllDepartment().then(res => {
        this.departList = res.body.data;
      })
    },
    // 选择指标后调取接口
    goalSelectChange(id) {
      getGoalAddData({ objectiveIndicatorId: id }).then(res => {
        let obj = res.body.data
        this.ruleForm.completionDate = obj.completionDate;
        this.ruleForm.type = obj.type;
        this.ruleForm.objectiveContent = obj.objectiveContent;
        this.ruleForm.objectiveExplain = obj.objectiveExplain;
        this.ruleForm.year = obj.year;
        this.ruleForm.indicatorNumber = obj.indicatorNumber
        this.$forceUpdate()
      })
    },
    // 部门改变
    departChange(id) {
      let obj = this.departList.find((item => {
        return item.id === id
      }))
      this.ruleForm.producerDepName = obj.name
      this.getUser(id);
      this.$forceUpdate()
    },
    responseDepartChange(id) {
      let obj = this.departList.find((item => {
        return item.id === id
      }))
      this.ruleForm.dutyDepName = obj.name
      getDepartUser({ demId: id }).then(res => {
        this.userList2 = res.body.data;
        this.ruleForm.dutyPersonEmpid = '';
      })
      this.$forceUpdate()
    },
    user(id, status) {
      let obj = this.userList.find((item => {
        return item.id === id
      }))
      if(status === 1) {
        this.ruleForm.producer = obj.name
      }
      if(status === 4) {
        let obj2 = this.userList2.find((item => {
        return item.id === id
      }))
        this.ruleForm.dutyPersonName = obj2.name
      }
      if(status === 3) {
        this.ruleForm.departmentHeadName = obj.name
      }
      this.$forceUpdate();
    },
    // 获取部门下面的人员
    getUser(id) {
      getDepartUser({ demId: id }).then(res => {
        this.ruleForm.departmentHeadEmpid = ''
        this.ruleForm.producerEmpId = ''
        this.userList = res.body.data;
      })
    },
    openDia() {
      this.dialogVisible = true;
    },
    closeDia() {
      this.dialogVisible = false;
      this.$refs['diaForm'].clearValidate()
    },

    // 获取模板列表
    getModulesList() {
      modulesList().then(res => {
        this.modules = res.body.data
      }) 
    },

    // 模板更改
    modelChange(a) {
      let obj = {}
      obj = this.modules.find(v => {
        return a === v.definitionId
      })
      this.ruleForm.key = obj.key
      // console.log(this.form)
    },

    // 保存的按钮
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let obj = {...this.ruleForm}
          // obj.examinedContent = JSON.stringify(this.tableData);
          if(this.$route.params.id) {
            editSplit({...obj}).then(res => {
              this.$message.success('编辑成功');
              this.$router.back();
            })
          }else{
            goalSplitAdd({...obj}).then(res => {
              this.$message.success('添加成功');
              this.$router.push('targetSplit');
            })
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.formBox {
  padding-top: 15px;
  padding-right: 10%;
  width: 70%;
  margin: auto;
}
.formBox /deep/ .el-form-item {
  margin-bottom: 25px;
}
</style>